import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const SectionHeading = ({ overline, title, copy, align = "left", testId }) => (
  <div className={align === "center" ? "text-center" : "text-left"} data-testid={testId}>
    <motion.p
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE }}
      className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold"
    >
      {overline}
    </motion.p>
    <div className="overflow-hidden mt-5">
      <motion.h2
        initial={{ y: "105%" }}
        whileInView={{ y: "0%" }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-white"
      >
        {title}
      </motion.h2>
    </div>
    {copy && (
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
        className={`mt-6 text-base text-neutral-400 font-light leading-relaxed max-w-xl ${
          align === "center" ? "mx-auto" : ""
        }`}
      >
        {copy}
      </motion.p>
    )}
  </div>
);

export default SectionHeading;
